/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Col_PortalInputs */

const cs_portals_col_portal = /** @type {(inputs: Portals_Col_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portál`)
};

const en_portals_col_portal = /** @type {(inputs: Portals_Col_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal`)
};

/**
* | output |
* | --- |
* | "Portal" |
*
* @param {Portals_Col_PortalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_col_portal = /** @type {((inputs?: Portals_Col_PortalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Col_PortalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_col_portal(inputs)
	return cs_portals_col_portal(inputs)
});